const tieneMasDeUnaHora = fecha => Date.now() - new Date(fecha).getTime() >= 60 * 60 * 1000;

const agregarBotonReintentar = (vm, row, data, columna) => {
    const btn = $("<button class='btn btn-sm btn-info' data-uniqueid='" + data.uniqueid + "'><i class='fa-solid fa-arrows-rotate'></i></button>");
    $(btn).on("click", function () { vm.reintentarFactura(data, this); });
    $("td", row).eq(columna).append(btn);
};

const mexico = (vm, row, data) => {

    const columna = 10;
    const host = vm.GLOBAL.SERVER_HOST;
    const empresa = vm.empresa;
    const td = $("td", row).eq(columna);

    // PRE FACTURA Y EMITIR
    if (data.public_hasp == null && data.documento_id == vm.GLOBAL.DOCUMENTO.FACTURA_ELECTRONICA) {

        const viewPRE = $("<a class='btn btn-sm btn-white' target='_blank' href='" + host + "/kubber/facturacion/api/v1/generate/" + empresa + "/" + data.uniqueid + "'><i class='fa-solid fa-file-pdf'></i> PRE FACTURA</a>");
        td.append(viewPRE);

        const enviarPRE = $("<button class='btn btn-sm btn-info' data-uniqueid='" + data.uniqueid + "'><i class='fa-solid fa-check'></i>EMITIR</button>");
        $(enviarPRE).on("click", function () { vm.reintentarFactura(data, this); });
        td.append(enviarPRE);
    }

    // OPCIONES
    if (data.public_hasp == null) {
        const opcionesBtn = $("<button title='CAMBIAR OPCIONES DE FACTURA NO EMITIDA' class='btn btn-sm bg-indigo'><i class='fa-solid fa-money-check-dollar'></i></button>");
        $(opcionesBtn).on("click", function () { vm.opcionesFactura(data, this); });
        td.append(opcionesBtn);
    }

    // INACTIVAR
    if (data.public_hasp == null) {
        const inactivarBtn = $("<button title='BORRAR FACTURA NO EMITIDA' class='btn btn-sm btn-danger'><i class='fa-solid fa-xmark'></i></button>");
        $(inactivarBtn).on("click", function () { vm.inactivarFactura(data, this); });
        td.append(inactivarBtn);
    }


    // FACTURA EMITIDA
    if (data.public_hasp != null && data.estado == "G") {

        const viewPDF = $("<a class='btn btn-sm btn-danger' target='_blank' href='" + host + "/kubber/facturacion/api/v1/generate/" + empresa + "/" + data.uniqueid + "'><i class='fa-solid fa-file-pdf'></i></a>");
        td.append(viewPDF);

        const viewXML = $("<a class='btn btn-sm bg-purple' target='_blank' href='" + host + "/kubber/facturacion/api/v1/generatexml/" + empresa + "/" + data.uniqueid + "'><i class='fa-solid fa-code'></i></a>");
        td.append(viewXML);

        const cancelBtn = $("<button class='btn btn-sm btn-secondary'><i class='fa-solid fa-trash'></i></button>");
        $(cancelBtn).on("click", function () { vm.cancelarFactura(data, this); });
        td.append(cancelBtn);

        
        const correoBtn = $("<button title='Reenviar correo' class='btn btn-sm btn-success'><i class='fa-solid fa-envelope'></i></button>");
        $(correoBtn).on("click", function () { vm.reenviarCorreo(data, this); });
        td.append(correoBtn);
        
    }

    // INFO 
    if (data.public_hasp == null && data.estado != "I") {
        const infoBtn = $("<button class='btn btn-sm btn-primary'><i class='fa-sharp fa-solid fa-circle-info'></i></button>");
        $(infoBtn).on("click", function () { vm.showInfo(data, this); });
        td.append(infoBtn);
    }

    // REINTENTAR 
    if (
        (data.public_hasp == null && (data.estado == "R" || data.estado == "G")) ||
        (data.public_hasp != null && data.estado == "R") ||
        (data.public_hasp == null && data.estado == "P" && tieneMasDeUnaHora(data.fecha))
    )
        agregarBotonReintentar(vm, row, data, columna);
};

export default mexico;